import OutlinedInput from '@mui/material/OutlinedInput'
import Select from '@mui/material/Select'
import RoleChip from './RoleChip';
import Box from '@mui/material/Box'

function RoleChipSelect({ children, ...props }) {

    return (
        <>
            <Select
                {...props}
                sx={{ width: 300 }}
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                input={<OutlinedInput />}
                renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map(s => <RoleChip key={s} name={s} />)}
                    </Box>
                )}
            >
                {children}
            </Select>
        </>
    );
}

export default RoleChipSelect
